module.exports = __webpack_public_path__ + "static/media/main_nav_arrow_white.64cfacae.svg";